import React, { useEffect, useState } from 'react';
import './manage-mobile-head.styles.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faBarcode,
    faBars,
    faBriefcase,
    faGear,
    faGem,
    faGlobeAmericas,
    faHome,
    faQrcode,
    faUsers,
    faX
} from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import {
    Link,
    useLocation,
    useNavigate
} from 'react-router-dom';
import ManageGameSidebar from '../manage-game-sidebar/manage-game-sidebar.component';
import ImageContainer from '@/components/SHARED/image-container/image-container.component';
import UserIcon from '@/components/layout-auth/user-icon/user-icon.component';
import ManageUserDropdown from './manage-user-dropdown.component';
import Modal from '@/components/modal/modal.component';
import QrCodeScanner from '../../qr-code-scanner/qr-code-scanner.component';
import QRCodeScannerV2 from '../../qr-code-scanner/qr-code-scanner-v2.component';
import useAnalytics from '@/utils/useAnalytics';

const ManageMobileHeader = ({
    gameData,
    gameElements,
    playerList,
    actionItems,
    setShowFeedbackModal,
    setShowGameInfoModal,
    orgs,
    role
}) => {

    const userProfile = useSelector(state => state.userData.userProfile);
    const screenSize = useSelector(state => state.contentData.screenSize);
    const membership = useSelector(state => state.userData.membership);
    const [menuOpen, setMenuOpen] = useState(false);
    const [showDropdown, setShowDropdown] = useState(false);
    const [showQrCodeScanner, setShowQrCodeScanner] = useState(false);
    const { trackEvent, trackException } = useAnalytics();
    const [ basePath, setBasePath ] = useState('/manage');
    const location = useLocation();

    const navigate = useNavigate();

    useEffect(() => {
        if (location.pathname.includes('/preview/manager')) {
            setBasePath('/preview/manager');
        } else {
            setBasePath('/manage');
        }
    }, [location])

    useEffect(() => {
        // document.getElementById('slide-menu').classList.toggle('show');
    }, [menuOpen])

    useEffect(() => {
        setMenuOpen(false);
        setShowDropdown(false);
        console.log(location.pathname);
    }, [location]);

    const toggleMenu = () => {
        setMenuOpen(!menuOpen);
    };

    const menuItems = [
        {
            'path': '',
            'label': 'My List'
        }
    ]

    return (
        <div className="manage-mobile-header">
            <div className='mobile-header__top'>
                <div className='mobile-header__menu-left'>
                    <button
                        className="mobile-header__menu-button"
                        id="slide-menu"
                        onClick={toggleMenu} >
                        <FontAwesomeIcon
                            icon={faBars} />
                    </button>
                    <div className={`mobile-header__logo ${screenSize}`}>
                        <ImageContainer
                            src={gameData.icon}
                            alt="game logo"
                            className={`${gameData.border_icon}-border`} />
                    </div>
                </div>
                <div className='mobile-header__menu-right'>
                    {
                        (userProfile) &&
                        <button
                            className='g-button text-only icon-button'
                            onClick={() => setShowDropdown(!showDropdown)} >
                            <UserIcon
                                className='clickable'
                                profile={userProfile}
                                reverse={true}
                                planIcon={true} />
                        </button>
                    }
                    {
                        (
                            userProfile &&
                            userProfile.appId !== 'preview-manager' &&
                            userProfile.appId !== 'preview-player'
                        ) && <ManageUserDropdown
                            show={showDropdown} />
                    }
                </div>
            </div>
            <div
                className='mobile-bottom-menu'>
                <Link to={`${basePath}/${gameData.path}`}>
                    <FontAwesomeIcon
                        className={`event-menu-item ${location.pathname === `${basePath}/${gameData.path}` ? "active" : ""
                            }`}
                        icon={faHome}
                        size='xl' />
                </Link>
                <Link to={`${basePath}/${gameData.path}/players`}>
                    <FontAwesomeIcon
                        className={`event-menu-item ${location.pathname.includes('/players') ? "active" : ""
                            }`}
                        icon={faUsers}
                        size='xl' />
                </Link>
                <Link to={`${basePath}/${gameData.path}/elements`}>
                    <FontAwesomeIcon
                        className={`event-menu-item ${location.pathname.includes(`${basePath}/${gameData.path}/elements`) ? "active" : ""
                            }`}
                        icon={faBriefcase}
                        size='xl' />
                </Link>
                <Link to={`${basePath}/${gameData.path}/distribute`}>
                    <FontAwesomeIcon
                        className={`event-menu-item ${location.pathname.includes('/distribute') ? "active" : ""
                            }`}
                        icon={faGem}
                        size='xl' />
                </Link>
                <Link to={`${basePath}/${gameData.path}/activity`}>
                    <FontAwesomeIcon
                        className={`event-menu-item ${location.pathname.includes('/activity') ? "active" : ""
                            }`}
                        icon={faGlobeAmericas}
                        size='xl' />
                </Link>
                <FontAwesomeIcon
                    className={`event-menu-item`}
                    icon={faBarcode}
                    size='xl'
                    onClick={() => setShowQrCodeScanner(true)} />
            </div>
            <div
                className={`mobile-header__menu-items ${menuOpen ? "show" : ""
                    }`}>
                <div
                    className='close-button'
                    onClick={() => setMenuOpen(!menuOpen)}>
                    <FontAwesomeIcon
                        icon={faX}
                        size='xl' />
                </div>
                <ManageGameSidebar
                    gameData={gameData}
                    actionItems={actionItems}
                    playerList={playerList}
                    setShowFeedbackModal={setShowFeedbackModal}
                    setShowGameInfoModal={setShowGameInfoModal}
                    gameElements={gameElements}
                    orgs={orgs}
                    role={role} />
            </div>
            <Modal
                show={showQrCodeScanner}
                cancel={() => setShowQrCodeScanner(false)}
                text="Scan a Player's QR Code"
                closeButton={true}>
                <div className='qr-code-scanner-container'>
                    {
                        (showQrCodeScanner) &&
                        <QRCodeScannerV2
                            onScanSuccess={(data) => {
                                setShowQrCodeScanner(false);
                                console.log('Scan successful:', data);
                                trackEvent(
                                    'player_qrcode_scanned_from_mobile_header',
                                    'Game Manager',
                                    `QR code scanned for player distribution.`,
                                    null,
                                    membership
                                )
                                navigate(`/manage/${gameData.path}/distribute?p=${data}`);
                            }}
                            onScanError={(error) => {
                                console.error('Scan error:', error);
                            }}
                        />
                    }
                </div>
            </Modal>
        </div>
    );
};

export default ManageMobileHeader;